<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ $t('ITEM.CREATE') }} {{ $t('ORDERS.ITEM') }}
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark color="indigo" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>
    <v-card class="mt-3" :loading="loading">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <order-business-form
              v-if="isLoadedOrder"
              v-model="order"
              :company="company"
              :action="action"
              :errors="errors.getAll()"
              @valid="valid = $event"
              @update-prop="clearErrorByName($event)"
            ></order-business-form>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              large
              class="float-right"
              color="success"
              :disabled="!valid"
              @click="submit"
              >{{ $t('BUTTON.SAVE') }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import order from '../../mixins/order';
import OrderBusinessForm from './../../../components/forms/OrderBusinessForm.vue';
import { mapActions, mapGetters } from 'vuex';
import { get } from 'lodash';
import errors from '@/modules/_global/mixins/errors';
import { REPETITIVE_BUSINESS } from '@/modules/orders/common/order-types';
import { CREATE } from '@/modules/_global/mixins/form-editable';

export default {
  name: 'BusinessOrderCreatePage',

  components: {
    OrderBusinessForm
  },

  mixins: [errors, order],

  props: {
    companyId: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    company: {},
    valid: false,
    action: CREATE
  }),

  computed: {
    ...mapGetters(['loading'])
  },

  mounted() {
    this.$vuetify.goTo(0);
    this.retrieveCompany(this.companyId).then(({ data: { data } }) => {
      this.company = {
        id: get(data, 'id'),
        name: get(data, 'name', ''),
        phone_1: get(data, 'phone', ''),
        phone_2: get(data, 'phone_additional', ''),
        email: get(data, 'email', ''),
        category: this.$t('SERVICES.B_CUSTOMER')
      };

      this.order = {
        is_tender: false,
        street: get(data, 'street', ''),
        zip: get(data, 'zip', ''),
        city: get(data, 'city', ''),
        type_id: REPETITIVE_BUSINESS
      };
    });
  },

  methods: {
    ...mapActions('order', ['storeOrderRB']),
    ...mapActions('company', ['retrieveCompany']),
    submit() {
      const order = {
        ...this.order,
        company_id: this.companyId
      };

      this.storeOrderRB({ companyId: this.companyId, order })
        .then(() => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$router.go(-1);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>
